var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4286 0H2.57143C1.15127 0 0 1.15127 0 2.57143V12.8571C0 14.2773 1.15127 15.4286 2.57143 15.4286H21.4286C22.8487 15.4286 24 14.2773 24 12.8571V2.57143C24 1.15127 22.8487 0 21.4286 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M21.4286 0H2.57143C1.15114 0 0 1.15114 0 2.57143V12.8571C0 14.2774 1.15114 15.4286 2.57143 15.4286H21.4286C22.8489 15.4286 24 14.2774 24 12.8571V2.57143C24 1.15114 22.8489 0 21.4286 0ZM23.1429 12.8571C23.1429 13.8026 22.374 14.5714 21.4286 14.5714H2.57143C1.626 14.5714 0.857143 13.8026 0.857143 12.8571V2.57143C0.857143 1.626 1.626 0.857143 2.57143 0.857143H21.4286C22.374 0.857143 23.1429 1.626 23.1429 2.57143V12.8571Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M21.4289 0.857178H2.57171C1.62456 0.857178 0.857422 1.62432 0.857422 2.57146V3.42861C0.857422 2.48146 1.62456 1.71432 2.57171 1.71432H21.4289C22.376 1.71432 23.1431 2.48146 23.1431 3.42861V2.57146C23.1431 1.62432 22.376 0.857178 21.4289 0.857178Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.93945 4.00879H14.0623V11.4171H9.93945V4.00879Z",
    fill: "#FF5F00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2015 7.71339C10.2015 6.27339 10.8692 4.89939 11.9946 4.00882C9.95293 2.39911 6.98122 2.75225 5.3715 4.80768C3.77465 6.84939 4.12779 9.80739 6.18322 11.418C7.8975 12.7662 10.2932 12.7662 12.0075 11.418C10.8684 10.5282 10.2015 9.15339 10.2015 7.71339Z",
    fill: "#EB001B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6262 7.71339C19.6262 10.3182 17.5185 12.4251 14.9145 12.4251C13.8542 12.4251 12.8334 12.072 12.0088 11.4171C14.0505 9.80739 14.4045 6.84939 12.7939 4.79396C12.5582 4.50596 12.2968 4.23082 12.0088 4.00882C14.0505 2.39911 17.0222 2.75225 18.6191 4.80768C19.2739 5.63225 19.6271 6.65311 19.6271 7.71339H19.6262Z",
    fill: "#F79E1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardMastercard);
export default __webpack_public_path__ + "static/media/card-mastercard.33a354f835e9fa62256d8b48af1725de.svg";
export { ForwardRef as ReactComponent };